// extracted by mini-css-extract-plugin
export default {"banned":"UserAdministration_banned__nUngD","shimmer":"UserAdministration_shimmer__nHyKU"};